export const restaurantOrdersIt = {
  title: {
    deliveryTakeaway: 'Delivery e Asporto',
    deliveryTakeawayConfiguration: 'Configurazione Delivery e Asporto',
    orderHistoryDocument: 'Storico ordini · Delivery e Asporto',
    orderHubEyebrow: 'Centrale ordini',
    operationalManagement: 'Gestione operativa',
  },
  workspace: {
    selectBranchToManage: 'Seleziona una sede per gestire {{title}}.',
    newOrder: 'Nuovo ordine',
    searchOrderPlaceholder: 'Cerca ordine…',
    orderTypeAriaLabel: 'Tipo ordine',
    channelDelivery: 'DELIVERY',
    channelTakeaway: 'ASPORTO',
    processedAriaLabel: 'Processati',
    processedTitle: 'Ordini processati',
    processed: 'Processati',
    refreshOrdersLabel: 'Aggiorna ordini',
    refreshOrdersTitle: 'Aggiorna ordini',
    attentionLabel: 'Da gestire',
    unsupportedStatesAlert:
      '{{count}} ordini hanno stati API non compatibili con il nuovo flusso.',
    unsupportedStatesHint:
      'Sono inclusi nel calendario, ma non possono essere assegnati automaticamente alle colonne. Verificare gli stati restituiti dal backend.',
  },
  board: {
    elapsedNow: 'Adesso',
    elapsedMinutesAgo: '{{minutes}} min fa',
    elapsedHoursAgo: '{{hours}} h fa',
    elapsedDaysAgo: '{{days}} g fa',
    productsCount: '{{count}} prodotti',
    paymentMethodTitle: 'Metodo di pagamento',
    orderCardAriaLabel:
      'Ordine {{id}} · {{name}}. Invio per aprire, spazio per trascinare.',
    columnSubtitles: {
      inArrivo: 'Nuovi ordini da valutare',
      accettato: 'Ordini confermati',
      inLavorazione: 'Ordini in preparazione',
      pronto: 'Pronti per ritiro o consegna',
    },
    archiveReadyTitle: 'Archivia ordini pronti',
    archiveReadyAriaLabel: 'Archivia ordini pronti',
    dropHere: 'Rilascia qui',
    noOrders: 'Nessun ordine',
    orderUpdatedRetry: 'Ordine aggiornato. Riprova con lo stato attuale.',
  },
  detail: {
    orderTitle: 'Ordine #{{id}} · {{channel}}',
    orderDetail: 'Dettaglio ordine',
    refreshOrderLabel: 'Aggiorna ordine',
    refreshOrderTitle: 'Aggiorna ordine',
    orderActivityLabel: 'Attività ordine',
    orderActivityTitle: 'Attività ordine',
    loadError: 'Impossibile caricare l’ordine.',
    scheduledDelivery: 'Consegna prevista',
    scheduledPickup: 'Ritiro previsto',
    deliveryAddress: 'Indirizzo di consegna',
    pickupPoint: 'Punto di ritiro',
    emptyAddress: '—',
    outcome: 'Esito:',
    orderDishes: 'Piatti dell’ordine',
    editDishes: 'Modifica piatti',
    allergens: 'Allergeni:',
    perDish: '{{price}} / piatto',
    deliveryFeeLine: 'Consegna {{fee}}',
    orderUpdatedToast: 'Ordine aggiornato.',
    operationFailed: 'Operazione non riuscita. Ricarica i dettagli e riprova.',
    moveOrder: 'Sposta ordine',
    orderNumber: 'Ordine #{{id}}',
    chooseStatus: 'Scegli lo stato',
    reopenToStatus: 'Riporta nello stato',
    chooseOperationalStatus: 'Scegli uno stato operativo',
    orderOutcome: 'Esito ordine',
    chooseReason: 'Scegli un motivo',
    confirmMove: 'Conferma lo spostamento',
    notifyCustomer: 'Notifica cliente',
    doNotNotify: 'Non notificare',
    unpaidTitle: 'Ordine non ancora pagato',
    unpaidBody:
      'Ordine non ancora pagato, sei sicuro di volerlo spostare in lavorazione?',
    unpaidHint:
      'Il pagamento resterà in sospeso. Questa operazione non addebita il cliente.',
    noActivity: 'Nessuna attività registrata.',
    depositNotAuthorizedApi:
      'L’acconto non è ancora autorizzato. Attendi l’autorizzazione di pagamento del cliente.',
  },
  create: {
    title: 'Nuovo ordine',
    description:
      'Scegli il servizio, aggiungi i prodotti e completa i dati del cliente.',
    loadServicesError: 'Impossibile caricare i servizi.',
    loadingServices: 'Caricamento servizi…',
    publishServiceHint:
      'Pubblica un servizio di Asporto o Delivery in Configurazioni.',
    whichService: 'Quale servizio vuoi usare?',
    loadingMenuSlots: 'Caricamento menu e orari…',
    loadMenuSlotsError: 'Impossibile caricare menu e orari.',
    noModeAvailable: 'Nessuna modalità disponibile per questo servizio.',
    operationFailed: 'Operazione non riuscita. Riprova.',
    addAtLeastOneProduct: 'Aggiungi almeno un prodotto.',
    productUnavailable: 'Un prodotto non è più disponibile.',
    checkProducts: 'Controlla i prodotti.',
    enterCustomerName: 'Inserisci nome e cognome del cliente.',
    enterValidPhone: 'Inserisci un telefono valido con prefisso.',
    fixOrClearEmail: 'Correggi l’email oppure lascia il campo vuoto.',
    chooseDayAndSlot: 'Scegli un giorno e un orario disponibili.',
    chooseActiveDriver:
      'Scegli un fattorino attivo o lascia “Assegna più tardi”.',
    enterFullDeliveryAddress:
      'Inserisci l’indirizzo di consegna completo di numero civico.',
    reloadService: 'Ricarica il servizio.',
    quoteExpired:
      'Il preventivo è scaduto. Controlla i dati e aggiorna il riepilogo.',
    stepsAriaLabel: 'Passaggi nuovo ordine',
    steps: {
      service: 'Servizio',
      products: 'Prodotti',
      customer: 'Cliente',
      confirm: 'Conferma',
    },
    footerProductsTotal: '{{count}} prodotti · {{total}}',
    footerTotalOrder: 'Totale ordine',
    footerDeliveryInSummary: 'Costi di consegna nel riepilogo',
    wait: 'Attendi…',
    stepActions: {
      chooseProducts: 'Scegli prodotti',
      customerDetails: 'Dati del cliente',
      reviewOrder: 'Controlla ordine',
      createOrder: 'Crea ordine',
    },
    channelSectionTitle: 'Come riceve l’ordine il cliente?',
    channelSectionHint:
      'Asporto: viene a ritirarlo. Delivery: lo consegniamo noi.',
    channelTakeaway: 'Asporto',
    channelDelivery: 'Delivery',
    changeChannelConfirm: 'Cambiare modalità e svuotare i prodotti inseriti?',
    whatToOrder: 'Cosa vuole ordinare?',
    menuCategoriesAriaLabel: 'Categorie menu',
    allMenu: 'Tutto il menu',
    otherProducts: 'Altri prodotti',
    searchProduct: 'Cerca un prodotto',
    searchProductPlaceholder: 'Nome del prodotto…',
    fromMenu: 'Dal menu',
    addProductAria: 'Aggiungi {{name}}',
    compose: 'Componi',
    add: 'Aggiungi',
    cartAriaLabel: 'Prodotti nell’ordine',
    yourOrder: 'Il tuo ordine',
    chooseProductToStart: 'Scegli un prodotto dal menu per iniziare.',
    noExtraOptions: 'Senza opzioni aggiuntive',
    decreaseQtyAria: 'Riduci quantità',
    decreaseQtyForAria: 'Riduci quantità di {{name}}',
    quantityForAria: 'Quantità di {{name}}',
    increaseQtyForAria: 'Aumenta quantità di {{name}}',
    anotherConfiguration: 'Altra configurazione',
    removeConfigurationAria: 'Rimuovi configurazione {{index}}',
    subtotal: 'Subtotale',
    customerAndFulfillment: 'Cliente e {{fulfillment}}',
    fulfillmentDelivery: 'consegna',
    fulfillmentPickup: 'ritiro',
    customerRequiredHint: 'Nome, cognome e telefono sono obbligatori.',
    emailOptional: 'Email (facoltativa)',
    emailPlaceholder: 'cliente@esempio.it',
    fullAddress: 'Indirizzo completo',
    fullAddressPlaceholder: 'Via, civico, CAP e città',
    driver: 'Fattorino',
    assignLater: 'Assegna più tardi',
    driversLoadError: 'Impossibile caricare i fattorini. Puoi assegnarlo dopo.',
    deliveryTime: 'Ora di consegna',
    pickupTime: 'Ora di ritiro',
    bookUntil: 'Puoi prenotare fino al {{date}}.',
    notesOptional: 'Note (facoltative)',
    notesPlaceholder: 'Citofono, indicazioni per la cucina…',
    reviewAndCreate: 'Controlla e crea l’ordine',
    driverLine: 'Fattorino:',
    toAssign: 'Da assegnare',
    afterCreateHint:
      'Dopo la creazione puoi gestire l’ordine e richiedere un acconto.',
    productConfigHint:
      'Scegli gli ingredienti per questa configurazione. Per ingredienti diversi aggiungi un’altra configurazione.',
    requiredSuffix: ' · obbligatorio',
    quantity: 'Quantità',
    reduceQuantityAria: 'Riduci quantità',
    addToOrder: 'Aggiungi all’ordine',
    saveChanges: 'Salva modifiche',
    selection: {
      quantityRange: 'Scegli una quantità tra 1 e 99.',
      productUnavailableForService:
        'Prodotto non disponibile per questo servizio.',
      optionUnavailable: 'Una delle opzioni selezionate non è disponibile.',
    },
    cartErrors: {
      invalidLine: 'Riga ordine non valida.',
      maxSameConfiguration:
        'Puoi aggiungere al massimo 99 unità della stessa configurazione.',
      maxConfigurations: 'Massimo 100 configurazioni per ordine.',
      configurationsRange: 'Aggiungi da 1 a 100 configurazioni.',
      invalidAmountOrPercentage: 'Importo o percentuale non validi.',
      checkOrderProducts: 'Controlla i prodotti dell’ordine.',
      minimumOrder: 'Ordine minimo: € {{amount}}.',
      invalidDeliveryFee: 'Costo di consegna non valido. Ricarica il servizio.',
    },
  },
  history: {
    selectBranch: 'Seleziona una sede per consultare gli ordini.',
    subtitleDefault: 'Delivery e Asporto',
    searchTitle: 'Cerca nello storico',
    searchHint:
      'Scegli il periodo o cerca un ordine. I risultati si aggiornano automaticamente.',
    searchPlaceholder: 'Numero ordine, cliente, prodotto o contatto…',
    moreFilters: 'Altri filtri',
    invalidDateRange: 'L’intervallo di date non è valido.',
    exporting: 'Esportazione…',
    exportCsv: 'Esporta CSV',
    exportFailed:
      'Esportazione non riuscita. Nessun file parziale è stato scaricato. Riprova.',
    driversListUnavailable: 'Elenco fattorini non disponibile.',
    searchUnavailable:
      'Ricerca non disponibile. I filtri non hanno restituito un risultato verificato.',
    searching: 'Ricerca ordini e riepiloghi…',
    exactMatch: 'Corrispondenza esatta',
    containsMatch: 'Ricerca per testo contenuto',
    exactMatchHint: 'I nomi più lunghi non sono inclusi.',
    ordersFound: 'Ordini trovati',
    ordersFoundHint: 'In base al periodo e ai filtri scelti',
    completedValue: 'Valore degli ordini completati',
    completedValueHint:
      '{{count}} ordini completati · importo totale, anche se non ancora pagato',
    stillUnpaid: 'Ancora da pagare',
    noUnpaidInResults: 'Nessun ordine da pagare tra i risultati',
    unpaidInResults: '{{count}} ordini non pagati tra i risultati',
    ordersByDriver: 'Ordini per fattorino',
    ordersByDriverHint: 'Assegnatario attuale, anche negli ordini archiviati.',
    driverSummary: '{{completed}} completati · {{unpaid}} da incassare',
    orderList: 'Elenco ordini',
    orderListHint: 'Usa “Dettagli” per aprire un ordine.',
    resultsPage: '{{total}} risultati · Pagina {{page}} di {{pages}}',
    loadingPage: 'Caricamento pagina…',
    noOrdersForFilters: 'Nessun ordine per questi filtri',
    table: {
      order: 'Ordine',
      dateTime: 'Data e ora',
      channel: 'Canale',
      orderStatus: 'Stato ordine',
      payment: 'Pagamento',
      driver: 'Fattorino',
      total: 'Totale',
      notAssigned: 'Non assegnato',
      openOrderAria: 'Apri ordine {{id}}',
    },
    modalProcessed: 'Ordini processati',
    modalHistory: 'Storico ordini',
    filters: {
      paid: 'Pagato',
      unpaid: 'Non pagato',
      allMethods: 'Tutti i metodi',
      allDrivers: 'Tutti',
      unassigned: 'Non assegnati',
      deliveryAndTakeaway: 'Delivery e asporto',
      allStatuses: 'Tutti',
      afterProcessed: 'Stato ordine dopo processato',
      sortBy: 'Ordina per',
      sortRecent: 'Più recenti',
      sortOldest: 'Meno recenti',
      sortTotalHigh: 'Totale più alto',
      unassignedOnly: 'Senza fattorino',
      driverFilter: 'Fattorino: {{name}}',
    },
    export: {
      incompleteResults: 'Risultati incompleti. Riprova.',
      filename: 'storico-ordini.csv',
      headers: {
        order: 'Ordine',
        customer: 'Cliente',
        email: 'Email',
        phone: 'Telefono',
        schedule: 'Consegna / ritiro',
        channel: 'Canale',
        products: 'Prodotti',
        driver: 'Fattorino',
        totalEur: 'Totale EUR',
        orderStatus: 'Stato ordine',
        paymentStatus: 'Stato pagamento',
        paymentMethod: 'Metodo pagamento',
      },
      productLine: '{{quantity}} × {{name}}',
    },
    pagination: {
      perPage: 'Per pagina',
      ordersCount: '{{count}} ordini',
      previous: 'Precedente',
      next: 'Successiva',
    },
    topCustomersHint:
      'Primi 10 per valore degli ordini completati, su tutti i risultati filtrati.',
    noCompletedInResults: 'Nessun ordine completato nei risultati.',
  },
  drivers: {
    manageHint: 'Gestisci i collaboratori assegnabili alle consegne.',
    addDriver: 'Aggiungi fattorino',
    loadError: 'Impossibile caricare i fattorini.',
    empty: 'Nessun fattorino configurato',
    columns: {
      driver: 'Fattorino',
      phone: 'Telefono',
      status: 'Stato',
      actions: 'Azioni',
    },
    active: 'Attivo',
    inactive: 'Disattivato',
    ordersAndMap: 'Ordini e mappa',
    deleteTitle: 'Elimina fattorino',
    deleteConfirm:
      'Eliminare {{name}}? L’accesso verrà revocato e gli ordini aperti torneranno non assegnati. Lo storico resterà conservato.',
    deleteAction: 'Elimina fattorino',
    deletedToast: 'Fattorino eliminato.',
    deleteError: 'Impossibile eliminare il fattorino.',
    editTitle: 'Modifica fattorino',
    newTitle: 'Nuovo fattorino',
    username: 'Nome di accesso',
    passwordNew: 'Password · almeno 4 caratteri',
    passwordKeep: 'Nuova password (lascia vuoto per mantenerla)',
    passwordMinError: 'Inserisci almeno 4 caratteri.',
    accessHint:
      'Il fattorino accede dal pulsante motorino nel menu pubblico. Condividi le credenziali direttamente con lui. La password non sarà più visualizzata.',
    activeToggleAria: 'Fattorino attivo',
    activeToggle: 'Fattorino attivo',
    savedToast: 'Fattorino salvato.',
    saveError: 'Impossibile salvare il fattorino.',
    createdByDriver: 'Creato dal fattorino:',
    assignedLabel: 'Fattorino assegnato',
    notAssigned: 'Non assegnato',
    deactivatedSuffix: ' · disattivato',
    deletedSuffix: ' · eliminato',
    driverLine: 'Fattorino:',
    assignSuccess: 'fattorino assegnato',
    unassignSuccess: 'Assegnazione rimossa',
    assignError: 'Impossibile assegnare il fattorino.',
    discountCard: 'Card sconto',
    giftCard: 'Gift Card:',
    giftCardCaptured: 'Addebitata',
    giftCardReleased: 'Rilasciata',
    giftCardReserved: 'Prenotata',
    amountDue: 'Da incassare:',
  },
  config: {
    title: 'Configurazione Delivery e Asporto',
    sectionAriaLabel: 'Servizi di asporto e delivery',
    introTitle: 'Gestisci come ricevere gli ordini',
    introBody:
      'Con Modifica imposti menu, giorni, orari e pagamenti di ogni servizio. Condividi il link o il QR code per far ordinare i clienti.',
    searchPlaceholder: 'Cerca un servizio...',
    newService: 'Nuovo servizio',
    templateLoadError: 'Impossibile caricare i dati iniziali.',
    servicesLoadError: 'Impossibile caricare i servizi.',
    emptySearch: 'Nessun servizio corrisponde alla ricerca',
    empty: 'Nessun servizio configurato',
    columns: {
      service: 'Servizio',
      orderType: 'Tipo di ordine',
      visibility: 'Visibilità',
      manageShare: 'Gestisci e condividi',
    },
    preparationMinutes: 'Preparazione {{minutes}} min',
    advanceDays: 'Ordini fino a {{days}} giorni in anticipo',
    deliveryPausedSuffix: ' · sospeso',
    visibleToCustomers: 'Visibile ai clienti',
    draftNotVisible: 'Bozza · non visibile',
    openPage: 'Apri pagina',
    servicesPerPage: 'Servizi per pagina',
    range: '{{start}}-{{end}} di {{total}}',
    previous: 'Precedente',
    next: 'Successiva',
    linkCopied: 'Link copiato.',
    copyManually: 'Copia manualmente il link mostrato.',
    removedToast: 'Servizio rimosso. Gli ordini esistenti sono conservati.',
    removeError: 'Impossibile rimuovere il servizio.',
    shareModalTitle: 'Link clienti · {{name}}',
    published: 'Pubblicato',
    draftPublishHint: 'Bozza · pubblica il servizio per ricevere ordini',
    publicLinkLabel: 'Link pubblico Delivery / Asporto',
    shareHint:
      'Il cliente sceglierà tra i canali abilitati e le fasce disponibili per questo servizio.',
    removeTitle: 'Rimuovi servizio',
    removeConfirm:
      'Vuoi rimuovere “{{name}}”? Il servizio non accetterà nuovi ordini. Gli ordini esistenti e lo storico saranno conservati.',
    removeAction: 'Rimuovi servizio',
    editor: {
      editTitle: 'Modifica servizio',
      newTitle: 'Nuovo servizio',
      stepService: '1 · Servizio',
      stepProducts: '2 · Prodotti',
      stepSchedulePayments: '3 · Calendario e pagamenti',
      savePublish: 'Salva e pubblica',
      saveDraft: 'Salva bozza',
      serviceName: 'Nome del servizio',
      serviceNameHint:
        'Questo nome sarà il titolo della pagina pubblica che i clienti aprono dal link o dal QR code per ordinare Delivery o Asporto.',
      chooseMenu: 'Scegli menu',
      menusLoadError: 'Impossibile caricare i menu.',
      enableTakeaway: 'Abilita Asporto',
      enableDelivery: 'Abilita Delivery',
      restaurantPhoto: 'Foto del ristorante (facoltativa)',
      restaurantPhotoHint:
        'Clicca per scegliere e caricare una foto dal tuo dispositivo.',
      removeRestaurantPhoto: 'Rimuovi foto del ristorante',
      photoLoading: 'Caricamento della foto…',
      photoUploadedToast: 'Foto caricata. Salva il servizio per confermare.',
      photoUploadError: 'Impossibile caricare la foto del ristorante.',
      photoNoUrl:
        'Il caricamento non ha restituito l’URL dell’immagine. Riprova.',
      productsIntro:
        'Scegli i prodotti disponibili e i prezzi per canale. Ingredienti e varianti provengono dal menu condiviso. Per confermare un prezzo modificato, premi Salva accanto al campo.',
      searchProductsPlaceholder: 'Cerca un prodotto o una sezione…',
      productsLoadError: 'Impossibile caricare i prodotti.',
      productsLoading: 'Caricamento prodotti…',
      noProducts: 'Nessun prodotto trovato',
      chooseMenuFirst: 'Scegli prima un menu',
      sectionControlsHint:
        '{{count}} prodotti · i controlli si applicano all’intera sezione, anche durante la ricerca.',
      partial: ' · Parziale',
      activeCount: '{{enabled}}/{{total}} attivi',
      sectionToggleAria: '{{channel}}: intera sezione {{name}}',
      product: 'Prodotto',
      takeaway: 'Asporto',
      delivery: 'Delivery',
      options: 'Ingredienti e opzioni',
      syncedWithMenu: ' · Sincronizzato con il Menu',
      priceAria: 'Prezzo {{channel}} {{name}}',
      savePriceAria: 'Salva prezzo {{channel}} {{name}}',
      invalidPrice: 'Inserisci un prezzo valido, maggiore o uguale a zero.',
      updateFailed: 'Aggiornamento non riuscito',
      productsUpdatedPartial:
        '{{completed}} di {{total}} prodotti aggiornati. Non aggiornati: {{failures}}',
      priceUpdatedToast: 'Prezzo aggiornato.',
      productsUpdatedToast: '{{count}} prodotti aggiornati.',
      menuLoadFailed:
        'Impossibile caricare il menu. Nessuna modifica applicata.',
      recipeSyncHint:
        'Gli interruttori dei prodotti sincronizzati aggiornano subito la ricetta, anche nel Menu e negli altri servizi che la usano. Anche i prezzi salvati qui aggiornano il Menu e gli altri servizi. Annulla non ripristina queste modifiche. Per i prodotti non sincronizzati, salva il servizio per confermare. Gli ingredienti si modificano nel Menu.',
      prepMinutes: 'Preparazione media (min)',
      slotMinutes: 'Durata degli intervalli di consegna/ritiro (minuti)',
      slotHint:
        'Con 15 minuti, il cliente può scegliere 19:00–19:15, poi 19:15–19:30. Il tempo di preparazione si imposta separatamente.',
      advanceDaysLabel: 'Anticipo massimo dell’ordine (giorni)',
      advanceDaysHint:
        'Con 7 giorni, il cliente può ordinare per una data entro i prossimi 7 giorni, negli orari di apertura configurati.',
      minimumOrder: 'Ordine minimo (€)',
      freeDeliveryFrom: 'Delivery gratuito da (€)',
      deliveryRadius: 'Raggio Delivery (km)',
      weeklyCalendar: 'Calendario settimanale · orari di ricezione ordini',
      from: 'Dalle',
      slotStartAria: 'Inizio fascia {{index}}',
      slotEndAria: 'Fine fascia {{index}}',
      removeSlotAria: 'Rimuovi fascia',
      addSlot: 'Aggiungi fascia',
      paymentMethods: 'Metodi di pagamento accettati',
      cardOnly: 'Solo carta',
      cashAndCard: 'Contanti e carta',
      stripeChecking: 'Verifica Stripe in corso…',
      stripeRequired:
        'Per abilitare la carta, completa la configurazione Stripe e l’onboarding della sede.',
      cardStripeError:
        'Per abilitare la carta, completa la configurazione Stripe e l’onboarding della sede.',
      publication: 'Pubblicazione',
      pauseDelivery: 'Sospendi temporaneamente Delivery',
      pauseDeliveryHint:
        'La sezione Delivery di questo servizio può essere momentaneamente disabilitata. Riattivala togliendo la spunta e salvando il servizio. L’asporto resta disponibile se abilitato.',
      publishService: 'Pubblica il servizio',
      savedPublishedToast: 'Servizio salvato come pubblicato.',
      savedDraftToast: 'Bozza salvata.',
      saveError: 'Impossibile salvare il servizio.',
      pendingPrices:
        'Salva i prezzi modificati con il pulsante accanto a ciascun prezzo prima di continuare.',
      distanceBandsUnsupported:
        'Il servizio API collegato deve essere aggiornato per salvare le fasce di consegna.',
      distanceBandsNotReturned:
        'Il server non ha restituito le fasce salvate. La configurazione resta aperta: ricarica il servizio prima di riprovare.',
      productDetailsTitle: 'Dettagli prodotto · {{name}}',
      productDetails: 'Dettagli prodotto',
      closeDetails: 'Chiudi dettagli',
      ingredients: 'Ingredienti:',
      allergens: 'Allergeni:',
      notSpecified: 'Non indicati',
      noOptionsForChannel: 'Nessuna opzione per questo canale',
      group: 'Gruppo',
      ingredient: 'Ingrediente',
      supplement: 'Supplemento',
      minMax: 'Min. {{min}}{{max}}',
      maxSuffix: ' · Max. {{max}}',
      weekdays: {
        monday: 'Lunedì',
        tuesday: 'Martedì',
        wednesday: 'Mercoledì',
        thursday: 'Giovedì',
        friday: 'Venerdì',
        saturday: 'Sabato',
        sunday: 'Domenica',
      },
    },
    validation: {
      serviceName: 'Inserisci un nome del servizio (massimo 120 caratteri).',
      chooseMenu: 'Scegli il menu del servizio.',
      enableChannel: 'Attiva almeno Delivery o Asporto.',
      integerRange: '{{label}}: inserisci un intero tra {{min}} e {{max}}.',
      preparation: 'Preparazione',
      slotDuration: 'Durata fascia',
      bookableDays: 'Giorni prenotabili',
      amounts: 'Inserisci importi positivi con massimo due decimali.',
      deliveryRadius:
        'Il raggio Delivery deve essere maggiore di 0 e massimo 100 km.',
      timezone: 'Inserisci un fuso orario valido.',
      location:
        'Completa indirizzo e coordinate nella configurazione della sede.',
      geocoding:
        'Il servizio di verifica dell’area Delivery non è configurato.',
      openingHours: 'Inserisci da 1 a 28 fasce di apertura.',
      openingHoursOrder:
        'Controlla le fasce orarie: la fine deve essere successiva all’inizio.',
      enableProduct: 'Abilita almeno un prodotto per un canale attivo.',
      productPrices: 'Controlla i prezzi dei prodotti.',
    },
  },
  modals: {
    archive: {
      title: 'Archivia ordini pronti',
      intro:
        'Gli ordini selezionati saranno archiviati: Delivery come Consegnato, Asporto come Ritirato. Il metodo di pagamento resta invariato.',
      markAllPaid: 'Segna come pagati tutti i selezionati',
      deliverySection: 'Delivery · Consegnato',
      takeawaySection: 'Asporto · Ritirato',
      paid: 'Pagato',
      noReadyOrders: 'Nessun ordine pronto.',
      archiving: 'Archiviazione…',
      archiveCount: 'Archivia {{count}} ordini',
      archiveError:
        'Archiviazione non riuscita. Ricarica gli ordini e riprova.',
    },
    processed: {
      title: 'Ordini processati · {{date}}',
      searchPlaceholder: 'Cerca cliente, telefono o numero ordine…',
      orderOutcome: 'Esito ordine',
      allReasons: 'Tutti i motivi',
      empty: 'Nessun ordine archiviato',
      columns: {
        order: 'Ordine',
        channel: 'Canale',
        schedule: 'Orario consegna / ritiro',
        total: 'Totale',
        driver: 'Fattorino',
        outcome: 'Esito',
        payment: 'Pagamento',
      },
      perPage: 'Per pagina',
      ordersCount: '{{count}} ordini',
      previous: 'Precedente',
      next: 'Successiva',
    },
    payment: {
      cardTitle: 'Pagamento con carta',
      loadingStripe: 'Caricamento del modulo Stripe…',
      loadError:
        'Impossibile caricare il pagamento. L’ordine è salvato e attende il pagamento.',
      retryPayment: 'Riprova pagamento',
      payAmount: 'Paga {{amount}}',
      confirmedOnPayment:
        'L’ordine sarà confermato al ricevimento del pagamento.',
      paymentFailed: 'Pagamento non riuscito. Riprova.',
      paymentIncomplete: 'Pagamento non completato. Riprova.',
      verifyFailed:
        'Impossibile verificare il pagamento. Riprova sullo stesso ordine.',
    },
    itemsEditor: {
      title: 'Modifica piatti',
      titleWithOrder: 'Modifica piatti · Ordine #{{id}}',
      loadError:
        'La modifica ordine richiede le nuove API del backend. Nessun dato è stato modificato.',
      loadingMenu: 'Caricamento menu…',
      notEditable: 'Questo ordine non è modificabile nello stato attuale.',
      saveError:
        'Impossibile salvare. Ricarica l’ordine se è stato modificato da un altro operatore.',
      menuChannel: 'Menu · {{channel}}',
      searchPlaceholder: 'Cerca un piatto o una sezione…',
      orderItems: 'Piatti dell’ordine · {{count}}',
      removeDishAria: 'Rimuovi piatto',
      quantity: 'Quantità',
      decreaseQtyAria: 'Riduci quantità',
      optionIssue:
        'Verifica disponibilità e numero minimo/massimo di ingredienti scelti.',
      addAtLeastOne:
        'Aggiungi almeno un piatto. Per annullare l’ordine usa l’azione dedicata.',
      verifiedTotal: 'Nuovo totale verificato',
      recalcHint:
        'Il server ricalcola prezzi e supplementi prima del salvataggio. Le modifiche restano locali fino a “Salva modifiche”.',
      verifyTotal: 'Verifica nuovo totale',
      saveChanges: 'Salva modifiche',
      unsavedConfirm: 'Uscire senza salvare le modifiche ai piatti?',
      dishFallback: 'Piatto {{index}}',
    },
  },
  address: {
    suggestionsUnavailable:
      'Suggerimenti non disponibili. Riprova tra poco per selezionare la via.',
    searching: 'Cerco indirizzi…',
    suggestionsCount:
      '{{count}} indirizzi suggeriti. Usa le frecce per scegliere e Invio per confermare.',
    notFound: 'Nessun indirizzo trovato. Controlla la via e aggiungi la città.',
    verifyStreet: 'Verifico via e numero civico…',
    verifyFailed:
      'Non riusciamo a verificare la via. Seleziona di nuovo un suggerimento per riprovare.',
    selectFromSuggestions:
      'Seleziona la via dai suggerimenti prima di continuare.',
    deliveryAddressSrOnly: 'Indirizzo di consegna',
    placeholder: 'Via, numero civico, città e CAP',
    suggestedAddressesAria: 'Indirizzi suggeriti',
    hint: 'Scegli la via dai suggerimenti e completa il numero civico.',
    streetNumber: 'Numero civico *',
    streetNumberPlaceholder: 'Es. 10, 10/A',
    deliveryAddressPreview: 'Indirizzo di consegna:',
    yourAddress: 'Il tuo indirizzo',
    streetOnlyCity:
      'Seleziona una via dai suggerimenti, non soltanto una città o una zona.',
    fullAddressItaly:
      'Seleziona un indirizzo completo di via e città in Italia.',
    streetNumberRequired: 'Inserisci il numero civico per continuare.',
    streetNumberInvalid:
      'Inserisci un numero civico valido, ad esempio 10, 10/A o 10 bis.',
  },
  pricing: {
    ariaLabel: 'Costo della consegna',
    title: 'Come calcoli il costo della consegna?',
    intro:
      'Scegli un costo uguale per tutti oppure un prezzo totale per ogni fascia di distanza.',
    fixedCost: 'Costo fisso',
    distanceBands: 'Fasce di distanza',
    fixedFeeLabel: 'Costo per ogni consegna (€)',
    fixedFeeHint:
      'Lo stesso importo per tutti gli indirizzi nel raggio Delivery.',
    bandsUnsupported:
      'Le API collegate non supportano ancora il salvataggio delle fasce. Puoi prepararle qui; il salvataggio sarà disponibile dopo l’aggiornamento del servizio.',
    bandsFlow:
      '1. Indirizzo nel raggio di {{radius}} km → 2. Percorso stradale → 3. Costo della fascia',
    bandsFlowHint:
      'Il prezzo è il totale della consegna. I km sono quelli percorsi su strada dal locale al cliente, sola andata. L’ultima fascia copre ogni distanza successiva per gli indirizzi già accettati.',
    allDistances: 'Tutte le distanze',
    overKm: 'Oltre {{km}} km',
    lastBandHint: 'Ultima fascia · nessun limite stradale aggiuntivo',
    bandUpTo: 'Fascia {{index}} · fino a (km)',
    bandFromZero: 'Da 0 km, limite incluso.',
    bandAfterPrevious: 'Oltre {{km}} km, limite incluso.',
    bandCost: 'Fascia {{index}} · costo totale (€)',
    removeBandAria: 'Rimuovi fascia {{index}}',
    addBand: 'Aggiungi fascia',
    bandChecksAria: 'Controlli fasce',
    simulateDistance: 'Simula un percorso stradale (km)',
    completeBandsForCost: 'Completa le fasce per vedere il costo.',
    enterValidDistance: 'Inserisci una distanza stradale valida.',
    costAtDistance: 'Costo della consegna a {{km}} km: {{price}}',
    previewHint:
      'Anteprima del prezzo di fascia, prima dell’eventuale soglia di consegna gratuita.',
    bandErrors: {
      count: 'Inserisci da 1 a 30 fasce di distanza.',
      lastBand:
        'Fascia {{index}}: l’ultima fascia copre tutte le distanze successive.',
      distance:
        'Fascia {{index}}: inserisci una distanza maggiore della precedente, fino a 1.000 km.',
      fee: 'Fascia {{index}}: inserisci un costo da 0 a 999.999,99 € con massimo due decimali.',
    },
  },
  payment: {
    sectionAria: 'Pagamento ordine',
    paid: 'Pagato',
    markPaid: 'Segna come pagato',
    paymentStatus: 'Stato pagamento',
    toPay: 'Da pagare',
    saving: 'Salvataggio pagamento…',
    specialStatusHint:
      'Il pagamento in corso, rimborsato o di un ordine annullato richiede una verifica dedicata.',
    updateError:
      'Impossibile aggiornare il pagamento. Ricarica l’ordine e riprova.',
    branchUnavailable: 'Sede non disponibile.',
    deposit: {
      ariaLabel: 'Richiedi acconto',
      title: 'Richiedi un acconto',
      intro:
        'Scegli la percentuale sul totale di {{total}}. Il cliente riceverà un link per pagare.',
      received: 'Ricevuto:',
      remaining: 'Resta da pagare:',
      defaultUnavailable:
        'Link di pagamento non disponibili: configura Stripe.',
      verifyBeforeNew:
        'Il pagamento di questo ordine richiede una verifica prima di richiedere un nuovo acconto.',
      creating: 'Creazione…',
      linkCreated: 'Link creato',
      createLinkFor: 'Crea link per {{amount}}',
      requested: 'Acconto richiesto: {{amount}}',
      customerLink: 'Link per il cliente',
      messageSent: 'Messaggio in invio / inviato',
      sending: 'Invio…',
      sendWhatsApp: 'Invia al cliente su WhatsApp',
      copied: 'Copiato',
      copyLink: 'Copia link',
      copyFromField: 'Copia il link dal campo qui sopra.',
      whatsAppHint:
        'Viene usato il messaggio “Link di pagamento” configurato nel Centro messaggi. Creare o inviare il link non segna l’ordine come pagato.',
      requestMismatch:
        'La richiesta restituita non corrisponde all’acconto scelto. Ricarica l’ordine.',
      requestUnavailable:
        'Richiesta non disponibile. Il servizio API deve supportare gli acconti sugli ordini.',
      sendNotConfirmed: 'Invio non confermato.',
      sendError:
        'Impossibile inviare il messaggio. Verifica la configurazione WhatsApp del messaggio Link di pagamento.',
      invalidPaymentRequest: 'Richiesta di pagamento non valida.',
      invalidPaymentLink: 'Link di pagamento non valido.',
    },
  },
  labels: {
    inArrivo: 'In arrivo',
    accettato: 'Accettato',
    archiviato: 'Processato',
    accept: 'Accetta ordine',
    archive: 'Segna come processato',
    reopen: 'Riapri ordine',
    eliminato: 'Eliminato',
    nonConsegnato: 'Non consegnato',
    delivery: 'Delivery',
    takeaway: 'Asporto',
    ricevuto: 'Ricevuto',
    presaInCarico: 'Preso in carico',
    confermato: 'Preso in carico',
    inAttesaDiPagamento: 'In attesa di pagamento',
    inLavorazione: 'In lavorazione',
    pronto: 'Pronto',
    ritirato: 'Ritirato',
    inConsegna: 'In consegna',
    consegnato: 'Consegnato',
    rifiutato: 'Rifiutato',
    annullato: 'Annullato',
    nonRitirato: 'Non ritirato',
    consegnaFallita: 'Consegna fallita',
    daPagare: 'Da pagare',
    inAttesa: 'In attesa',
    pagato: 'Pagato',
    parzialmentePagato: 'Acconto ricevuto',
    unspecified: 'Da definire',
    fallito: 'Fallito',
    rimborsato: 'Rimborsato',
    cash: 'Contanti',
    card: 'Carta',
    takeCharge: 'Prendi in carico',
    reject: 'Rifiuta ordine',
    prepare: 'Inizia preparazione',
    ready: 'Segna pronto',
    assign: 'Assegna fattorino',
    dispatch: 'Parti per la consegna',
    collect: 'Conferma ritiro',
    deliver: 'Conferma consegna',
    fail: 'Segnala problema',
    cancel: 'Annulla ordine',
    cashPaid: 'Registra incasso contanti',
    refund: 'Rimborsa su carta',
    cashRefund: 'Registra rimborso contanti',
    notCollected: 'Non ritirato',
    active: 'Da gestire',
    completed: 'Completati',
    issues: 'Annullati / problemi',
    scheduleAsap: 'Appena possibile',
  },
};
